import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { config } from '@services/config';
import { QuoteOriginSearchResponse } from '@lio/api-types';

export interface QuoteOriginSearchRequestQuery {
  name?: string;
  sort?: string;
  pageLimit?: number;
  pageOffset?: number;
}

export const quoteOriginKeys = {
  search: ['quote-origin'] as const,
  searchWithParams: (params: QuoteOriginSearchRequestQuery) => [...quoteOriginKeys.search, params] as const,
};

const getQuery = (params: QuoteOriginSearchRequestQuery) => {
  const query = new URLSearchParams();
  if (params?.name) query.append('name', params.name);
  if (params?.sort) query.append('sort', params.sort);
  if (params?.pageLimit) query.append('pageLimit', params.pageLimit.toString());
  if (params?.pageOffset !== undefined) query.append('pageOffset', params.pageOffset.toString());
  return query.toString();
};

export const useSearchQuoteOrigin = (params: QuoteOriginSearchRequestQuery = {}) => {
  const client = useClient();
  const queryParams = getQuery({ ...params, pageLimit: params.pageLimit ?? 100 });

  const result = useQuery<QuoteOriginSearchResponse, Error>({
    queryKey: quoteOriginKeys.searchWithParams(params),
    queryFn: () => client.get(`quote-origin?${queryParams}`).json<QuoteOriginSearchResponse>(),
    ...config,
  });

  return { ...result, items: result.data?.items ?? [] };
};
